import React from 'react'
import { react, js, css3, html, postgre, node, bootstrap, tailwind, git, sequelize } from '../assets/icons'
function Habilidades() {
  return (
    <div id="habilidades" className="w-full flex scroll-mt-20 justify-start items-center flex-col text-6xl h-screen dark:bg-black">
      <h2 className="text-lavander">Skillset</h2>
      <hr className="w-1/2 h-3 text-white my-8 "/>
      <div className="w-full flex flex-wrap justify-center text-xl md:w-3/4 md:text-3xl ml-0 md:ml-16">
        <div className="w-1/3 flex items-center mx-6 md:w-1/4">
        <img src={react} alt="react" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>ReactJs</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 mr-8 md:w-1/4">
        <img src={js} alt="javascript" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>Javascript</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 md:w-1/4">
        <img src={css3} alt="css" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>CSS</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 md:w-1/4">
        <img src={html} alt="html" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>HTML</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 mr-8 md:w-1/4">
        <img src={postgre} alt="postgre" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>PostgreSQL</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 md:w-1/4">
        <img src={node} alt="node" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>NodeJs</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 mr-8 md:w-1/4">
        <img src={tailwind} alt="tailwind" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>TailwindCss</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 md:w-1/4">
        <img src={bootstrap} alt="bootstrap" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>Boostrap</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 md:w-1/4">
        <img src={git} alt="git" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>Git</span>
        </div>
        <div className="w-1/3 flex items-center mx-6 md:w-1/4">
        <img src={sequelize} alt="git" className='w-10 m-4 grayscale ease-in-out duration-300 hover:grayscale-0 md:w-16'/>
        <span>Sequelize</span>
        </div>
        <div className="w-1/3 flex items-center justify-center mx-0 md:w-1/4 md:mx-8 text-2xl md:text-4xl">
        <span className="text-opacity-70 grayscale-0 ease-in-out duration-300 hover:brightness-125">Express</span>
        </div>
      </div>
    </div>
  )
}

export default Habilidades
